// extracted by mini-css-extract-plugin
export default {"executivesMatches":"ExecutivesMatches_executivesMatches__66gz4","pagination":"ExecutivesMatches_pagination__pyK6i"};